import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import RankingSection from "@/pages/home/components/RankingSection";
import NewReleaseSection from "@/pages/home/components/NewReleaseSection";
import PicksSection from "@/pages/home/components/PicksSection";
import ScheduleSection from "@/pages/home/components/ScheduleSection";
import ExploreSection from "@/pages/home/components/ExploreSection";
import TrendsSection from "@/pages/home/components/TrendsSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <Navbar />
      <main>
        <Hero />
        <RankingSection />
        <NewReleaseSection />
        <PicksSection />
        <ScheduleSection />
        <ExploreSection />
        <TrendsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}